"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getNavigator = void 0;
const BottomNavigationNavigator_1 = require("./BottomNavigationNavigator");
const DrawerNavigator_1 = require("./DrawerNavigator");
const StackNavigator_1 = require("./StackNavigator");
const SwitchNavigator_1 = require("./SwitchNavigator");
const TabNavigator_1 = require("./TabNavigator");
const NavigatorMap = {
    'bottom-tab': BottomNavigationNavigator_1.BottomNavigation,
    'bottom-tabs': BottomNavigationNavigator_1.BottomNavigation,
    drawer: DrawerNavigator_1.Drawer,
    'bottom-navigation': BottomNavigationNavigator_1.BottomNavigation,
    'material-bottom-tab': BottomNavigationNavigator_1.BottomNavigation,
    'material-bottom-tabs': BottomNavigationNavigator_1.BottomNavigation,
    tab: TabNavigator_1.Tab,
    tabs: TabNavigator_1.Tab,
    'native-stack': StackNavigator_1.Stack,
    stack: StackNavigator_1.Stack,
    switch: SwitchNavigator_1.Switch,
};
/**
 * Get Navigator by type (V5)
 * @param type
 * @param BB
 */
const getNavigator = (type) => {
    return NavigatorMap[type || 'stack'];
};
exports.getNavigator = getNavigator;
